import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';
/**
 *
 * @returns {검색 박스용 셀렉트}
 */
interface IOptionList {
  key?: string | number;
  value?: string | number;
  text?: string | number;
  name?: string | number;
  id?: string | number;
}
interface IProps {
  optionList?: IOptionList[];
  onChange?: (e: any) => void;
  value?: string | number;
  style?: React.CSSProperties;
  placeholder?: string;
  allowClear?: boolean;
}
const SelectSearch: React.FC<IProps> = ({
  optionList,
  onChange,
  value,
  style,
  placeholder,
  allowClear,
}) => {
  return (
    <StyledSelect
      onChange={onChange}
      value={value}
      bordered={false}
      placeholder={placeholder}
      style={style}
      allowClear={allowClear}
    >
      {optionList?.map((v) => (
        <Select.Option key={v.key} value={v.value}>
          {v.text}
        </Select.Option>
      ))}
    </StyledSelect>
  );
};
export default SelectSearch;

const StyledSelect = styled(Select)`
  position: relative;
  height: 100%;
  width: 10rem;
  background-color: #fff;
  box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 5%);
  margin-right: 1rem;
  padding-top: 0.35rem;

  .ant-select-selection-placeholder {
    /* margin-top: 5px; */
    color: #bdbdbd;
  }
`;
